/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ProductsInputs */

const en_nav_products = /** @type {(inputs: Nav_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products`)
};

const es_nav_products = /** @type {(inputs: Nav_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productos`)
};

/**
* | output |
* | --- |
* | "Products" |
*
* @param {Nav_ProductsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_products = /** @type {((inputs?: Nav_ProductsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ProductsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_products(inputs)
	return es_nav_products(inputs)
});